module.exports = __webpack_public_path__ + "img/icon-topic-diseases.a29cca50.svg";